import React from "react";
import { Link, useNavigate } from "react-router-dom";

/**
 * PublicNav - Header for Public Experience Mode (unauthenticated demo pages)
 * Used on: Public Library, Demo Player
 * Simplified to: Logo + Sign In button only
 */
const PublicNav = () => {
  const navigate = useNavigate();

  const handleSignIn = () => {
    navigate('/login');
  };

  return (
    <nav className="sticky top-0 z-40 border-b border-slate-800 bg-slate-950/90 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-3 py-2 sm:px-4 sm:py-3 gap-2">
        {/* Logo Only - Always routes to / - Smaller on mobile */}
        <Link to="/" className="flex items-center group flex-shrink-0">
          <img 
            src="/newaudia-logo.jpg" 
            alt="NewAudia™" 
            className="h-10 sm:h-12 md:h-16 w-auto rounded transition-transform group-hover:scale-105"
          />
        </Link>

        {/* Right Side - Sign In Button (Always Visible on All Devices) */}
        <button
          onClick={handleSignIn}
          className="rounded-full bg-slate-800 px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm text-slate-100 hover:bg-slate-700 transition-colors whitespace-nowrap flex-shrink-0"
        >
          Sign In
        </button>
      </div>
    </nav>
  );
};

export default PublicNav;
